(function ($) {
  setTimeout(function(){
    if($('.page-utilities__account-text').css('display')=='block'){
      var formatusername=$('.user-greeting__name').html().replace(/\+/g, ' ');
      $('.user-greeting__name').html(formatusername);
    }
  }, 2000);
})(jQuery);

